<template>
  <div
    class="row legend-key-value"
    :data-testid="testId"
  >
    <legend-row
      :hide-legend-prop="hideLegend"
      :tooltip-info="tooltipInfo"
      :legend="legend"
      :class="{ 'gordita-400-11': !bold, 'gordita-500-11-m': bold }"
      :text-color="textColor"
      :style="`line-height: ${height}; width: ${titleWidth}`"
      v-bind="$attrs"
    />
    <span
      v-if="value !== undefined"
      :class="{ 'sans-400-12 legend-key-value--value': !bold, 'sans-500-11': bold }"
      :style="{ color: textColor }"
      >{{ value?.toLocaleString() }}</span
    >
  </div>
</template>
<script>
import legendRow from './legend-row.vue';

export default {
  components: { legendRow },
  props: {
    testId: {
      type: String,
      required: true,
    },
    textColor: String,
    bold: Boolean,
    height: {
      type: String,
      default: '16px',
    },
    titleWidth: {
      type: String,
      default: '96px',
    },
    value: {
      type: [String, Number],
    },
    legend: {
      type: Boolean,
      default: true,
    },
    tooltipInfo: {
      type: Object,
    },
    hideLegend: {
      type: Boolean,
    },
  },
};
</script>
<style lang="scss" scoped>
.legend-key-value {
  flex-wrap: nowrap;
}
</style>
